import $ from 'jquery';
import { clickEvent, isTouch } from './utils';

const $body = $('body');
const $html = $('html');

function init (){
  bindEvents();
  addHelperClasses();
}

function bindEvents() {
  $('.info-button').on(clickEvent, toggleInfoBox);
  $('.overlay').on(clickEvent, toggleInfoBox);
  $('.info-box').find('.close').on(clickEvent, toggleInfoBox);
}

function addHelperClasses() {
  if (isTouch) {
    $html.addClass('has-touch');
  }
}

function toggleInfoBox(evt) {
  evt.stopPropagation();
  evt.preventDefault();
  $('.info-box').toggleClass('is-active');
  $('.overlay').toggleClass('is-active');
  $('body').toggleClass('info-box-is-active');
}

export default {
  init
}
